export default function () {
  return this.sendEvent('auth.logout', {})
}
